import React from 'react';
//<ContentDate published={dateinfo.published} amended={dateinfo.amended} />

export const ContentDate = (props)=>{return (
<div className="reviseddate"></div>
)};